export function getCurrentPath() {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  return url;
}
